import { Pagination } from 'react-bootstrap';
import React from 'react';
import styled from 'styled-components';

const SearchPaginationContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  flex-direction: column;
  color: #94a3b8;

  .pagination {
    flex: 1 1 auto;
    justify-content: space-between;
    margin: 3px;
  }

  .page-item .page-link {
    background-color: #000;
    border-color: #1f2937;
    color: #94a3b8;
  }

  .page-item .page-link:hover,
  .page-item .page-link:focus {
    background-color: #0f172a;
    border-color: #334155;
    color: #cbd5e1;
    box-shadow: none;
  }

  .page-item.disabled .page-link {
    background-color: #030712;
    border-color: #1f2937;
    color: #64748b;
  }
`;

interface ISearchPaginationProps {
  onPreviousClick: () => void;
  onNextClick: () => void;
  isFirstPage: boolean;
  isLastPage: boolean;
  totalRecords: number;
  isDisabled: boolean;
  pageSize?: number;
  compactLabel?: boolean;
}

const SearchPagination: React.FC<ISearchPaginationProps> = (props) => {
  const pageSize = props.pageSize ?? 5;
  const centerLabel = props.compactLabel
    ? `${pageSize} per page`
    : props.totalRecords
      ? `${props.totalRecords.toLocaleString()} records`
      : 'No Records';

  return (
    <>
      {props.totalRecords > pageSize && (
        <SearchPaginationContainer>
          <Pagination size="sm">
            <Pagination.First
              disabled={props.isFirstPage || props.isDisabled}
              onClick={props.onPreviousClick}
            />
            {centerLabel}
            <Pagination.Last
              disabled={props.isLastPage || props.isDisabled}
              onClick={props.onNextClick}
            />
          </Pagination>
        </SearchPaginationContainer>
      )}
    </>
  );
};

export default SearchPagination;
